import { Injectable, OnInit, Renderer2 } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { DatabaseService } from 'src/_services/DatabaseService'
import { DialogComponent } from './dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material';


@Injectable({ providedIn: 'root' })
export class sessionStorage implements OnInit {
    loading = false;
    alert: any;
    st_user: any = {};
    nexturl: any;
    dialogRef: MatDialogRef<any>;


    constructor(private route: ActivatedRoute, private router: Router, private dialogs: MatDialog, public db: DatabaseService, public dialog: DialogComponent) {

    }

    ngOnInit() {
        this.st_user.st_log = false;
        console.log(this.st_user);
    }

    getSession(): Observable<any> {
        this.st_user = JSON.parse(localStorage.getItem('st_user')) || 'http://sirca.abacusdesk.com'
        return of(this.st_user);
    }


    LogOutSession() {
        this.st_user = {};
        this.st_user.st_log = false;
        // this.dialogRef.close();
        this.db.can_active = '';
        localStorage.removeItem('st_user');
    }


}
